<div  class="m-0 text-lg text-[#53565b] flex items-start flex-col">

  <p  [class]=" 'sm:mb-[8px] mt-[8px] text-sm leading-5'">
    <span class="font-weight-bold-blue" > Recent uploads · {{ isLoading ? '': fileList.length + ' item'}}{{fileList.length>1?'s':''}}
    </span>
  </p>
</div>
@if (!fileList?.length && !isLoading) {
  <div class="flex flex-col w-full ">
    <div  class=" bg-[#FFFFFF]  text-center ">
      <p  style="color: #515765;" class=" text-xl	 mt-[18px] font-semibold">Nothing to show (yet)</p>
      <p  style="color: #515765;" class=" text-sm	 font-normal">Click ‘refresh’ below after uploading items from your mobile device.</p>
      <img src="assets/images/no-file-mobile.svg" style="padding: 12px;" class=" bg-[#FFFFFF]  " />
      <button
        class="app__btn--primary  mt-0 max-[480px]:items-center w-[296px] max-[480px]:h-[38px] max-[480px]:m-0"
        type="submit"
        style="margin: auto;"
        (click)="refreshFile()"
        >
        <mat-icon>refresh</mat-icon> Refresh
      </button>
    </div>
  </div>
}
@if (fileList?.length && !isLoading) {
  <div
    class="flex flex-col w-full  rounded-xl border-solid border border-[#53565B38]  mt-[16px] ">
    <div>
      <div class="flex justify-between  " >
        @if (origin == 'onboarding') {
          <div class="flex justify-between  w-full" >
            <p    class="px-2 text-base font-normal decoration-[#010B18] mt-4" >
              Uploads <b>• {{completedCount}} of {{fileList?.length}}</b> Items Complete
            </p>
            <button
              class="app__btn--primary max-h-6 mx-0 text-xs leading-6 items-center w-[98px] h-[26px]  p-0"
              type="submit"
              style="margin: auto;margin-right: 12px !important;"
              (click)="refreshFile()"
              >
              <mat-icon>refresh</mat-icon> Refresh
            </button>
          </div>
        }
        @if (origin == 'mobile') {
          <p class="px-2 text-base font-normal decoration-[#010B18] mt-4" >
            Recent Uploads <b>• {{completedCount}}</b> Items <mat-icon
            class="relative top-1.5 cursor-pointer text-[#ffffff] rounded-[100px] bg-[#25508E] "
          (click)="refreshFile()" >refresh</mat-icon>
        </p>
      }
      <div>
      </div>
    </div>
    <div>
      <div style="height: 38px;" class=" flex justify-between border-solid border-y border-[#53565B38]">
        <div style="width: 40px;">
        </div>
         <h6 style="color: #ABA5A3; height: 38px;
         margin-bottom: 0px;
         line-height: 38px !important;" class="pl-3	  w-5/12 font-semibold text-sm" >Files</h6>
        <h6 style="color: #ABA5A3; height: 38px;
            margin-bottom: 0px;
            line-height: 38px !important;" class="pl-3	  w-2/12 font-semibold text-sm" >Uploaded</h6>
         <h6  style="color: #ABA5A3; height: 38px;
         margin-bottom: 0px;
         line-height: 38px !important;" class=" text-center w-2/12 font-semibold text-sm" >Size</h6>
         <h6 style="color: #ABA5A3; height: 38px;
         margin-bottom: 0px;
         line-height: 38px !important;" class=" text-center w-3/12 font-semibold text-sm" >Status</h6>
      </div>
      @for (file of fileList; track file; let i = $index; let last = $last) {
        <div class=" flex justify-between border-solid  border-[#53565B38] m-0 h-12" [style.border-bottom]="last ? '0px' : '1px'" >
          <div style="width: 40px;" class=" m-0  font-semibold text-sm text-truncate h-12 " >
            <mat-checkbox
              style="margin-top: 6px;margin-left: 6px;"
              type="checkbox"
              class="checkbox-input"
              [(ngModel)]="file.checked"
              (change)="toggleFilterItem($event,file)"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
          </div>
          <p class="pl-3	 w-5/12  m-0  font-semibold text-sm text-truncate h-12 " style="line-height: 48px !important;color: #18191c;" >
            <img src="assets/images/file-icon.svg" />
            {{file.name  }}
          </p>
          <p class="pl-3	 w-2/12  m-0  font-semibold text-sm text-truncate h-12 " style="line-height: 48px !important;color: #18191c;" >
            {{file.updated_at | date  }}
          </p>
          <p class="w-2/12 text-center  m-0 h-12" style="line-height: 48px;">
            {{file.size | sizeConvertor}}
          </p>
          <div  class="pt-3.5 text-center w-3/12 h-12 m-0">
            <img src="assets/images/completed-check.svg" />
          </div>
        </div>
      }
    </div>
  </div>
</div>
}
@if (isLoading) {
  <div class="loader-container mt-[24px]" style="width: 100%;display: flex;flex-direction: column;">
    @for (item of loadingItems; track item) {
      <div>
        <div class="flex loader-body" style="width: 100% !important;" id="{{ item.id }}">
          <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
            <div class="ph-col-12" style="padding: 0px !important">
              <div class="ph-row">
                <div class="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

